import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=fadfe09c&"
import script from "./contact.vue?vue&type=script&lang=ts&"
export * from "./contact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports